export default __webpack_public_path__ + "static/media/videoPoster2.7adc5ba6.jpg";